/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.14",
    versionName: "0.2.0-nightly.2025.12.14",
    versionChannel: "nightly",
    buildDate: "2025-12-14T00:08:15.667Z",
    commitHash: "de228f4a181e959366950583c55b4a36209c05d2",
};
